
import { Component } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import Editable from '@/mixins/Editable';
import VWrapper from '@/components/shared/VWrapper.vue';
import { namespace } from 'vuex-class';
import { Venue } from '@/interfaces/models/Venue';
import { Constrain } from '@/interfaces/models/Constrain';
import EditConstrainLoader from '../../components/constrain/EditConstrainLoader.vue';
import ConstrainForm from '../../components/constrain/ConstrainForm.vue';
import Notification from '@/mixins/Notification';

const venue = namespace('venue');
const constrain = namespace('constrain');

@Component({
  components: { ConstrainForm, EditConstrainLoader, VWrapper },
})
export default class EditConstrain extends mixins(Editable, Notification) {
  @venue.State('active') public venue!: Venue;

  @constrain.Action('store') public store!: any;
  @constrain.Action('update') public update!: any;
  @constrain.Action('show') public show!: any;
  @constrain.State('active') public active!: Constrain;

  public $refs!: {
    form: InstanceType<typeof ConstrainForm> & { getData: () => any; validate: any };
  };

  get title() {
    return this.editing ? 'constrain.edit' : 'constrain.create';
  }

  get constrain() {
    if (this.editing && this.active) {
      return this.active;
    }

    return null;
  }

  public async mounted() {
    if (this.editing) {
      this.$startLoading('constrain');
      await this.show({ id: this.id });
      this.$stopLoading('constrain');
    }
    if (this.editing && !this.active) {
      this.$router.push({ name: 'constrain.index', query: { ...this.$route.query } });
    }
    if (!this.editing && !this.venue) {
      this.$router.push({ name: 'constrain.index', query: { ...this.$route.query } });
    }
  }

  public save() {
    this.$refs.form.validate().then(async (res: boolean) => {
      if (res) {
        if (this.editing) {
          await this.update({ ...this.$refs.form.getData(), id: this.id });
        } else {
          await this.store({ ...this.$refs.form.getData(), venue: this.venue._id });
        }
        this.$router.push({ name: 'constrain.index', query: { ...this.$route.query } });
      } else {
        this.notifyError('notification.form');
      }
    });
  }
}
